import newPassword from './newPassword'

const schema = {
  newPassword,
}

export default schema
